import { convertBbpressForumsListToTable } from './SortableForumsListing.js';
import ProductNewsTicker from './ProductNewsTicker.js';
import SidebarNav from './SidebarNav.js';
import TableOfContents from './TableOfContents.js';
import ServiceNavMenu from './ServiceNavMenu.js';
import NotificationsPanel from './NotificationsBell/NotificationPanel.js';
import { initFilters } from './filters';
import { initRecentlyPurchasedReportsBanner } from './RecentlyPurchasedReportsBanner.js';
import { initAnnouncementBar } from './AnnouncementBar.js';

function displayGoodTickerLogos()
{
  for (const logoContainer of document.querySelectorAll('.post-ticker-logo-container')) {
    for (const img of logoContainer.querySelectorAll('img')) {
      if (img.naturalWidth) {
        img.style.visibility = 'visible';
        img.style.position = 'static';
        break;
      }
    }
  }
}

function addQuoteApiContext()
{
  if (!('tickerInfo' in window) || window.tickerInfo.exchange.toLowerCase() !== 'asx') {
    return;
  }

  for (const section of document.querySelectorAll('.quoteapi-section')) {
    section.dataset.quoteapi = `context symbol=${ window.tickerInfo.symbol }.${ window.tickerInfo.exchange } liveness=delayed`;
  }
}

function runPostContentInlineCode()
{
    const textNodes = Array.from(document.querySelector('.entry-content.wp-block-post-content')?.childNodes ?? [])
        .filter(node => node.nodeName === '#text' && node.textContent.trim() !== '');
    textNodes.forEach(textNode => {
        const firstChar = textNode.textContent.trim()[0];
        const wrappingTag = firstChar === '.' || firstChar === '#' ? 'style' : 'script';
        const wrapper = document.createElement(wrappingTag);

        wrapper.innerHTML = textNode.textContent;
        textNode.parentElement.insertBefore(wrapper, textNode);
        textNode.remove();
    });
}

document.addEventListener('DOMContentLoaded', () => {
  new SidebarNav().init();
  new TableOfContents().init();
  new ServiceNavMenu().init();
  new NotificationsPanel().init();
  initFilters();
  addQuoteApiContext();
  runPostContentInlineCode();
  convertBbpressForumsListToTable();
  initRecentlyPurchasedReportsBanner();
  initAnnouncementBar();

  new ProductNewsTicker().init();
});

window.addEventListener('load', () => {
  displayGoodTickerLogos();
});
